import Typography from 'Components/UI/Typography';

export default Typography;
